import { render } from "./FolderComponent.vue?vue&type=template&id=3ea7235a&scoped=true"
import script from "./FolderComponent.vue?vue&type=script&lang=js"
export * from "./FolderComponent.vue?vue&type=script&lang=js"

import "./FolderComponent.vue?vue&type=style&index=0&id=3ea7235a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea7235a"]])

export default __exports__